import React, { useState } from 'react';
import { FaWhatsapp, FaPhone } from 'react-icons/fa';
import './FloatingButtons.css';
import { CONTACT_INFO } from '../config';

const FloatingButtons = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleCall = () => {
    window.location.href = `tel:${CONTACT_INFO.phoneRaw}`;
  };

  const handleWhatsApp = () => {
    window.open(`https://wa.me/${CONTACT_INFO.whatsapp}`, '_blank');
  };

  return (
    <div className={`floating-buttons ${isOpen ? 'open' : ''}`}>
      <button 
        className="floating-button whatsapp-btn"
        onClick={handleWhatsApp}
        title="WhatsApp"
      >
        <FaWhatsapp size={24} />
        <span className="btn-text">WhatsApp</span>
      </button>
      <button 
        className="floating-button call-btn"
        onClick={handleCall}
        title="Ara"
      >
        <FaPhone size={24} />
        <span className="btn-text">Ara</span>
      </button>
    </div>
  );
};

export default FloatingButtons;
